export const environment = {
  production: true,
  apiEndpoint: 'https://api-dev.jankalyan.life/',
  // apiEndpoint: './api/v1/',
};
